import React from 'react';
import { FlameIcon, CalendarCheckIcon, ZapIcon, ClipboardCheckIcon, ShieldCheckIcon, LayoutTemplateIcon, GiftIcon, SparklesIcon, ArrowRightIcon } from 'lucide-react';
const bonuses = [{
  number: '01',
  icon: FlameIcon,
  title: 'Kit Prima Lezione Perfetta',
  desc: "Attività di accoglienza e diagnostica per impostare subito l'autorità in classe.",
  value: 12
}, {
  number: '02',
  icon: CalendarCheckIcon,
  title: 'Checklist Curriculum MIUR',
  desc: 'Il tracker settimanale per non arrivare mai più a maggio in ritardo.',
  value: 15
}, {
  number: '03',
  icon: ZapIcon,
  title: '30 Attività Rompighiaccio Express',
  desc: "Mini-sfide di logica e calcolo per attivare l'attenzione in meno di 5 minuti.",
  value: 14
}, {
  number: '04',
  icon: ClipboardCheckIcon,
  title: 'Rubriche Flash di Valutazione',
  desc: '12 griglie pronte per correggere compiti e interrogazioni in 60 secondi.',
  value: 17
}, {
  number: '05',
  icon: ShieldCheckIcon,
  title: 'Pacchetto Recupero Pre-Verifica',
  desc: 'Routine di 20 minuti per preparare gli studenti prima del test.',
  value: 14
}, {
  number: '06',
  icon: LayoutTemplateIcon,
  title: '8 Template "Classe Visiva"',
  desc: 'Strutture professionali pronte per creare le tue slide in 10 minuti.',
  value: 15
}];
const totalValue = bonuses.reduce((sum, b) => sum + b.value, 0);
export function BonusSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-28">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(245,158,11,0.08) 0%, transparent 70%)'
    }} data-id="element-29"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.05) 0%, transparent 70%)'
    }} data-id="element-30"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-31">
        <div className="text-center mb-10 sm:mb-14" data-id="element-32">
          <span className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-secondary uppercase tracking-[0.2em] mb-3 sm:mb-4 bg-secondary/10 border border-secondary/20 px-4 py-1.5 rounded-full" data-id="element-33">
            <GiftIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-34" />
            Bonus inclusi
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight leading-tight" data-id="element-35">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-yellow-400" data-id="element-36">
              6 Bonus Esclusivi
            </span>
            <br className="hidden sm:block" data-id="element-37" />
            <span data-id="element-38"> nel tuo Kit, senza costi extra</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg mt-4 max-w-2xl mx-auto leading-relaxed" data-id="element-39">
            Strumenti aggiuntivi del valore di{' '}
            <span className="text-badge-red font-black line-through" data-id="element-40">
              € {totalValue}
            </span>{' '}
            regalati con l'acquisto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5" data-id="element-41">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-5 sm:p-6 flex items-start gap-4 sm:gap-5 transition-all duration-300 hover:-translate-y-1 hover:border-secondary/40 hover:shadow-[0_10px_30px_rgba(245,158,11,0.15)] group relative overflow-hidden" data-id="element-42">
                <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-secondary to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-43"></div>
                <div className="absolute top-3 right-3 text-xl sm:text-2xl font-black text-secondary/15 leading-none pointer-events-none" data-id="element-44">
                  {bonus.number}
                </div>

                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-secondary/25 to-secondary/5 border border-secondary/30 flex items-center justify-center flex-shrink-0 group-hover:from-secondary/35 group-hover:border-secondary/50 transition-colors shadow-inner" data-id="element-45">
                  <Icon className="w-6 h-6 sm:w-7 sm:h-7 text-secondary" strokeWidth={2.2} data-id="element-46" />
                </div>

                <div className="flex-1 min-w-0" data-id="element-47">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap" data-id="element-48">
                    <span className="text-text-sec text-xs sm:text-sm font-medium line-through" data-id="element-49">
                      € {bonus.value}
                    </span>
                    <span className="bg-cta-green/15 text-cta-green border border-cta-green/30 px-2 py-0.5 rounded-md font-black text-[10px] sm:text-xs" data-id="element-50">
                      GRATIS
                    </span>
                  </div>
                  <h4 className="text-text-main font-black text-base sm:text-lg leading-tight mb-1.5" data-id="element-51">
                    {bonus.title}
                  </h4>
                  <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-52">
                    {bonus.desc}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="mt-10 sm:mt-14 bg-gradient-to-br from-secondary/15 to-secondary/5 border-2 border-secondary/30 rounded-2xl sm:rounded-3xl p-6 sm:p-8 max-w-3xl mx-auto relative overflow-hidden" data-id="element-53">
          <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-secondary/10 blur-3xl pointer-events-none" data-id="element-54"></div>
          <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-8 relative z-10" data-id="element-55">
            <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-secondary/20 border border-secondary/40 flex items-center justify-center" data-id="element-56">
              <SparklesIcon className="w-8 h-8 sm:w-10 sm:h-10 text-secondary" strokeWidth={2.5} data-id="element-57" />
            </div>
            <div className="flex-1 text-center sm:text-left" data-id="element-58">
              <p className="text-text-sec text-xs sm:text-sm uppercase tracking-wider font-bold mb-1" data-id="element-59">
                Valore totale dei bonus
              </p>
              <div className="flex items-baseline justify-center sm:justify-start gap-3 flex-wrap" data-id="element-60">
                <span className="text-badge-red font-black text-2xl sm:text-4xl line-through" data-id="element-61">
                  € {totalValue}
                </span>
                <ArrowRightIcon className="w-5 h-5 text-text-sec" data-id="element-62" />
                <span className="text-cta-green font-black text-2xl sm:text-4xl" data-id="element-63">
                  INCLUSI GRATIS
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center" data-id="element-64">
          <a href="#pricing" className="inline-flex items-center gap-2 text-cta-green font-bold text-sm sm:text-base hover:gap-3 transition-all" data-id="element-65">
            Voglio il Kit con tutti i bonus
            <ArrowRightIcon className="w-4 h-4" strokeWidth={2.5} data-id="element-66" />
          </a>
        </div>
      </div>
    </section>;
}